import React, {PropTypes} from "react";

const Footer = (props) => {

  return (<footer className="text-center" style={{height: '10px'}}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <p>2016 - {new Date().getFullYear()} © Quikr India Private Limited.</p>
          </div>
        </div>
      </div>
    </footer>

  );

};

Footer.proptypes = {};

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/common/utils/Footer.js
 **/